export default __webpack_public_path__ + "static/media/1_StThomas.fac5a149.mp3";